import { render, staticRenderFns } from "./SituacionLaboralShow.vue?vue&type=template&id=5af08614"
import script from "./SituacionLaboralShow.vue?vue&type=script&lang=js"
export * from "./SituacionLaboralShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports